<svg [attr.width]="width" [attr.height]="svgHeight">
    <rect x="0" y="0" [attr.width]="width" [attr.height]="svgHeight" [attr.fill]="'#ededed'"></rect>
    <rect x="0" y="0" [attr.width]="levelWidth" [attr.height]="svgHeight" [attr.fill]="backColor"></rect>
    <text x="10" y="50%" dominant-baseline="middle" class="left-legend" [attr.fill]="foreColor">{{label}}</text>
    <text [attr.x]="width - 10" y="50%" dominant-baseline="middle" class="right-legend" [attr.fill]="foreColor">{{percent}}</text>
</svg>
